import React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'
import { DatePickerWrapper } from './DatePickerWrapper'
import { FaIcon } from '@/lib/fa'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import FullChartViewToggle from './FullChartViewToggle'

type AddBusinessTripNavigationProps = {
  dateFrom: Moment
  onDateChange: (newDate: Moment) => void
}

const AddBusinessTripNavigation: React.FC<AddBusinessTripNavigationProps> = ({
  dateFrom,
  onDateChange,
}) => {
  const handleDateChange = (dateString: string | null) => {
    if (dateString) {
      const newDate = moment(dateString)
      onDateChange(newDate)
    }
  }

  const goToPreviousDay = React.useCallback(() => {
    onDateChange(dateFrom.clone().subtract(1, 'day'))
  }, [dateFrom, onDateChange])

  const goToNextDay = React.useCallback(() => {
    onDateChange(dateFrom.clone().add(1, 'day'))
  }, [dateFrom, onDateChange])

  const { t } = useLocalize()
  return (
    <div className="tw-relative tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-2">
      <div className="tw-flex tw-items-center tw-gap-2">
        <p className="tw-text-sm tw-font-normal tw-text-content-base">{t('common.date')}</p>
        <DatePickerWrapper
          iconAlign="left"
          size="small"
          placeholder={t('common.select-date')}
          clearable={false}
          confirmSelection={false}
          value={dateFrom.format('YYYY-MM-DD')}
          setValue={handleDateChange}
        />
      </div>
      <div className="tw-flex tw-items-center tw-gap-1 tw-self-end tw-pb-0.5">
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white hover:tw-bg-gray-100"
          onClick={goToPreviousDay}
          title={t('driverViolations.previous-day')}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </button>
        <button
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white hover:tw-bg-gray-100"
          onClick={goToNextDay}
          title={t('driverViolations.next-day')}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </button>
      </div>
      <FullChartViewToggle />
    </div>
  )
}

export default AddBusinessTripNavigation
